// extracted by mini-css-extract-plugin
export var cardIcon = "_7n-5";
export var cardIconUnframed = "_7n-9";
export var checkboxCard = "_7n-0";
export var checkboxCardSelected = "_7n-4";
export var disabled = "_7n-2";
export var interactive = "_7n-1";
export var outerBorder = "_7n-3";
export var spacerMedium = "_7n-8";
export var spacerSmall = "_7n-7";
export var spacerXsmall = "_7n-6";